module.exports = __webpack_public_path__ + "img/bg.12b732e0.png";